(() => {
  const normalize = value => value.normalize('NFKD').replace(/[\u0300-\u036f]/g, '').toLocaleLowerCase().replace(/[^\p{L}\p{N}]+/gu, ' ').trim();
  const ignored = new Set(['a', 'an', 'the', 'i', 'my', 'do', 'does', 'how', 'what', 'where', 'is', 'are', 'can', 'to', 'of', 'for', 'please']);
  const setup = scope => scope.querySelectorAll('[data-mm-faq]').forEach(root => {
    if (root.dataset.faqReady) return;
    const input = root.querySelector('[data-mm-faq-input]');
    const filter = root.querySelector('[data-mm-faq-filter]');
    if (!input || !filter) return;
    root.dataset.faqReady = 'true';
    const sections = [...root.querySelectorAll('[data-mm-faq-section]')];
    const questions = sections.flatMap(section => [...section.querySelectorAll('details')]);
    const searchable = new Map(questions.map(item => [item, normalize(item.textContent)]));
    const previous = new Map();
    const jumps = [...root.querySelectorAll('.mmhd-jumps a')];
    const status = root.querySelector('[data-mm-faq-status]');
    const contact = root.querySelector('[data-mm-faq-contact]');
    let filtering = false;
    const render = () => {
      const query = normalize(input.value);
      const words = query.split(' ').filter(word => word && !ignored.has(word));
      const active = words.length > 0;
      if (active && !filtering) questions.forEach(item => previous.set(item, item.open));
      let count = 0;
      questions.forEach(item => {
        const matches = !active || words.every(word => searchable.get(item).includes(word));
        item.hidden = !matches;
        if (matches) count++;
        if (active) item.open = matches;
        else if (filtering) item.open = previous.get(item) || false;
      });
      sections.forEach(section => {
        section.hidden = ![...section.querySelectorAll('details')].some(item => !item.hidden);
        jumps.filter(link => link.hash === `#${section.id}`).forEach(link => link.hidden = section.hidden);
      });
      root.querySelector('.mmhd-jumps').hidden = count === 0;
      status.textContent = count ? root.dataset.count.replace('__COUNT__', String(count)) : root.dataset.none;
      contact.hidden = count > 0;
      filtering = active;
    };
    input.addEventListener('input', render);
    input.addEventListener('keydown', event => {
      if (event.key === 'Escape') { event.preventDefault(); input.value = ''; render(); }
      if (event.key === 'Enter') event.preventDefault();
    });
    root.querySelector('[data-mm-faq-clear]').addEventListener('click', () => { input.value = ''; render(); input.focus(); });
    filter.hidden = false;
    render();
  });
  setup(document);
  document.addEventListener('shopify:section:load', event => setup(event.target));
})();
